/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDay24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDay24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m13.247 5-.25-4h-2l-.25 4h2.5ZM7.307 6.655l-3.282-2.3-1.247 1.563 2.97 2.69 1.56-1.953ZM1.047 13.462l3.845-1.13.554 2.438-3.956.642-.443-1.95ZM7.818 17.759l-1.515 3.71 1.8.87 1.966-3.492-2.25-1.088ZM15.851 22.351l-1.954-3.5 2.255-1.08 1.503 3.716-1.804.864ZM18.535 14.79l3.953.657.45-1.949-3.841-1.143-.563 2.436ZM21.242 5.944l-2.98 2.68-1.552-1.958L20 4.376l1.242 1.568Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDay = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDay(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '24':
            return <IconDay24 {...iconProps} />;
        default:
            return <IconDay24 {...iconProps} />;
    }
});
